var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuBox"},[_c('ul',[_c('li',[_vm._v("1")]),_vm._v(" "),_c('li',[_vm._v("2")]),_vm._v(" "),_c('li',[_vm._v("3")]),_vm._v(" "),_c('li',[_vm._v("4")]),_vm._v(" "),_c('li',[_vm._v("5")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb1b9d98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout/components/Mobile.vue
// module id = SyAG
// module chunks = 1